import type { ApiError } from '../types';

// 4xx responses are deterministic (not found, forbidden, invalid input) —
// retrying can't change the outcome, and retries hold gates in their loading
// state (withRetryStatus), delaying pages that treat a 4xx as a legitimate
// answer (e.g. "no current audit" 404s).
export const shouldRetryOnError = (error: ApiError | undefined) => {
  if (error?.statusCode && error.statusCode >= 400 && error.statusCode < 500) {
    return false;
  }

  return true;
};
